<div class="w-full h-full flex bg-white relative">
    <!-- Recurring route details -->
    <div class="h-full w-1/2 flex-1 border-r relative">
        <!-- Breadcrum Header-->
        <div class="breadcrum-header border-b border-gray-200 flex items-center p-2 primary-font text-base font-normal">
            <div class="flex min-w-fit mr-2 icon-button" (click)="emittActions({isClosed: true})"><i class="ti ti-chevron-left text-2xl text-gray-500"></i></div>
            <div class="flex-1 truncate">
                <ol class="flex items-center whitespace-nowrap primary-font text-base font-normal text-gray-700">
                    <li class="inline-flex items-center">
                        <div (click)="emittActions({isClosed: true})"
                            class="text-gray-700 cursor-pointer hover:font-medium focus:outline-none focus:text-gray-600 dark:text-neutral-500 dark:hover:text-gray-500 dark:focus:text-gray-500">
                            {{'text.routes' | translate}}
                        </div>
                    </li>
                </ol>
            </div>
        </div>
        <div *ngIf="!isLoading">
            <!-- Route name and description -->
            <div class="primary-font text-base font-normal p-4 pt-2 border-b text-gray-700 flex flex-col space-y-2">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-2">
                        <div class="min-w-fit">
                            <div class="min-w-4 min-h-4 rounded-sm" [style.backgroundColor]="rrDetails?.color"></div>
                        </div>
                        <span class="text-gray-800 font-semibold text-break">{{rrDetails?.recurring_route_name || ''}}</span>
                    </div>
                    <div class="min-w-fit icon-button" [matMenuTriggerFor]="routeMasterContextMenu"
                        [matMenuTriggerData]="{ rrDetails: rrDetails }">
                        <i class="ti ti-dots-vertical text-2xl"></i>
                    </div>
                </div>
                <div class="text-gray-600 primary-font text-base break-words max-h-32 overflow-y-auto zuper-scrollbar"
                    id="master-route-description" *ngIf="rrDetails?.recurring_route_description">
                    {{rrDetails?.recurring_route_description || ''}}
                </div>
                <!-- Assigned to button -->
                <div class="flex items-center font-medium text-base primary-font cursor-pointer w-fit space-x-2"
                    style="color: #0277BD;" *ngIf="!rrDetails?.assigned_to_formatted?.length"
                    (click)="$event?.stopPropagation();updateRouteInstanceAssignedTo(rrDetails, 'recurringRoute')"
                    [ngxTippy]="routeInstanceAssignedToContent" [tippyProps]="routeInstanceUserAssignmentTippyProps">
                    <i class="ti ti-user-plus text-2xl"></i>
                    <span>{{'assign.employee.title' | translate}}</span>
                </div>
                <div class="group flex items-center" *ngIf="rrDetails?.assigned_to_formatted?.length">
                    <!-- Assigned users list -->
                    <div class="flex items-center max-w-max cursor-pointer group assigned-to" #masterAssignedToBtn
                        (click)="$event?.stopPropagation();updateRouteInstanceAssignedTo(rrDetails, 'recurringRoute')"
                        [ngxTippy]="routeInstanceAssignedToContent"
                        [tippyProps]="routeInstanceUserAssignmentTippyProps">
                        <div *ngFor="let assignedUser of rrDetails?.assigned_to_formatted.slice(0, maxAssigedToprofile); let i=index"
                            class="relative"
                            [ngStyle]="{'margin-left.px': i === 0 ? 0 : -7+i , 'z-index': maxAssigedToprofile - i}">
                            <img *ngIf="assignedUser?.hasValidProfilePicture"
                                class="h-6 w-6 relative rounded-full ring-2 ring-white" loading="lazy"
                                src="{{assignedUser?.user?.profile_picture}}" alt=""
                                title="{{assignedUser?.user?.first_name || ''}} {{assignedUser?.user?.last_name || ''}}">
                            <div *ngIf="!assignedUser?.hasValidProfilePicture"
                                title="{{assignedUser?.user?.first_name || ''}} {{assignedUser?.user?.last_name || ''}}"
                                class="flex items-center justify-center h-6 w-6 ring-2 ring-white rounded-full uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200 ng-star-inserted">
                                {{(assignedUser?.user?.first_name || '').slice(0,1)}}
                            </div>
                        </div>
                        <span *ngIf="rrDetails?.assigned_to_formatted?.length > maxAssigedToprofile"
                            class='primary-font relative text-base text-gray-500 ml-1.5'
                            [ngStyle]="{'margin-left.px': 6}">
                            + {{rrDetails?.assigned_to_formatted?.length - maxAssigedToprofile}}
                            {{'text.more' | translate}}</span>
                    </div>
                    <div class="bg-white ring-2 ring-gray-300 ml-1 flex justify-center items-center opacity-0 shadow-lg font-medium text-center h-5 w-5 relative rounded-full group-hover:opacity-100"
                        (click)="masterAssignedToBtn.click()"
                        [ngClass]=" {  'ml-1.5': rrDetails?.assigned_to_formatted?.length > maxAssigedToprofile, 'hidden': routeInstanceUserAssignTippyData.onShow }">
                        <i class="ti ti-user-plus text-2xl font-medium"></i>
                    </div>
                </div>
            </div>
            <!-- Recurrence details -->
            <div class="primary-font text-base font-normal p-4 border-b text-gray-700" *ngIf="rrDetails?.rrule_text">
                <div class="flex items-center gap-2">
                    <i class="ti ti-repeat text-2xl text-gray-700 text-light-blue"></i>
                    <span class="text-gray-800 font-normal mr-1">
                        {{'text.repeats' | translate}}
                        <span class="font-semibold ml-1">{{rrDetails?.rrule_text}}</span>
                        <span class="font-semibold ml-1">{{'text.at' | translate}}</span>
                        <span class="font-semibold ml-1">{{rrDetails?.routeStartTime}}</span>
                    </span>
                </div>
            </div>
            <!-- Jobs list -->
            <div class="primary-font text-base font-normal p-4">
                <span class="text-gray-700 font-medium text-base my-2">{{'text.jobs' | translate}}</span>
                <div class="overflow-y-auto zuper-scrollbar w-full job-list my-4" id="master-route-job-list">
                    <ol class=" overflow-x-hidden space-y-8 py-2">
                        <!-- Start location -->
                        <li class="relative flex-1" *ngIf="rrDetails?.startLocation">
                            <div class="flex font-medium w-full">
                                <div class="min-w-fit flex-0">
                                    <span
                                        class="w-8 h-8 border-transparent rounded-full flex justify-center items-center mr-3 z-10 text-sm"
                                        [style.background]="rrDetails?.primaryColor || '#0172CB'">
                                        <i class="ti ti-home text-2xl"
                                            [style.color]="rrDetails?.secondaryColor || '#ffffff'"></i>
                                    </span>
                                </div>
                                <div class="flex flex-col primary-font text-base text-gray-700 w-11/12 flex-1">
                                    <span class="font-semibold text-break">{{rrDetails?.startLocation || ''}}</span>
                                </div>
                            </div>
                        </li>
                        <!-- Job details (n) -->
                        <li class="relative flex-1"
                            *ngFor="let recurringJob of rrDetails?.recurring_jobs_details; let i = index;">
                            <div class="flex font-medium w-full">
                                <div class="min-w-fit flex-0">
                                    <span
                                        class="w-8 h-8 border-transparent rounded-full flex justify-center items-center mr-3 z-10 text-sm"
                                        [style.background]="rrDetails?.primaryColor || '#0172CB'">
                                        <span class="text-base font-normal"
                                            [style.color]="rrDetails?.secondaryColor || '#ffffff'">{{i + 1}}</span>
                                    </span>
                                </div>
                                <div class="flex flex-col primary-font text-base text-gray-700 w-7/12 flex-1">
                                    <span class="font-semibold text-break">{{recurringJob?.job_title}}</span>
                                    <span class="text-gray-600 font-normal flex-0 mt-1" *ngIf="recurringJob?.startTime && recurringJob?.endTime">{{recurringJob?.startTime}} -
                                        {{recurringJob?.endTime}}</span>
                                    <span
                                        class="text-gray-500 font-normal text-break">{{recurringJob?.customerAddress
                                        || ''}}</span>
                                </div>
                                <div class="min-w-fit h-fit flex space-x-1">
                                    <div class="icon-button"
                                        [matMenuTriggerFor]="routeMasterJobContextMenu"
                                        [matMenuTriggerData]="{ routeDetails: rrDetails, jobDetails: recurringJob, source: 'recurringRoute' }">
                                        <i class="ti ti-dots-vertical text-2xl"></i>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <!-- End location -->
                        <li class="relative flex-1" *ngIf="rrDetails?.endLocation">
                            <div class="flex font-medium w-full">
                                <div class="min-w-fit flex-0">
                                    <span
                                        class="w-8 h-8  border-transparent rounded-full flex justify-center items-center mr-3 z-10 text-sm"
                                        [style.background]="rrDetails?.primaryColor || '#0172CB'">
                                        <div class="w-2 h-2 text-base"
                                            [style.background]="rrDetails?.secondaryColor || '#ffffff'"></div>
                                    </span>
                                </div>
                                <div class="flex flex-col primary-font text-base text-gray-700 w-11/12 flex-1">
                                    <span class="font-semibold text-break"> {{rrDetails?.endLocation || ''}}</span>
                                </div>
                            </div>
                        </li>
                    </ol>
                </div>
            </div>
            <!-- Footer -->
            <div
                class="absolute flex w-full bottom-0 p-4 justify-between left-0 primary-font text-base border-t bg-white">
                <button type="button" (click)="openAddJobs(rrDetails)"
                    class="px-6 items-center font-medium py-2 border b-1 border-gray-300 shadow-sm rounded-md bg-white hover:bg-gray-100 focus:outline-none">
                    {{'route.add.job' | translate}}
                </button>
                <button (click)="toggleViewRouteSeries(true)"
                    class="px-6 flex items-center gap-2 py-2 font-medium border b-1 border-gray-300 shadow-sm rounded-md bg-white hover:bg-gray-100 focus:outline-none">
                    <span>{{'recurring_route.view_series' | translate}}</span>
                    <i class="ti ti-arrow-right text-2xl text-gray-700"></i>
                </button>
            </div>
        </div>
        <div class="my-3">
            <lazy-loader *ngIf="isLoading"></lazy-loader>
        </div>

    </div>
    <div class="h-full w-1/2 flex-1 border-r relative flex" *ngIf="routeSeriesSegment.isOpened">
        <div class="h-full w-full">
            <!-- Breadcrum Header-->
            <div class="breadcrum-header border-b border-gray-200 flex items-center p-2 pl-2">
                <div class="flex-0 mr-2 icon-button" *ngIf="breadcrumbData.right.secondChild"
                    (click)="changeRouteInstanceType()">
                    <i class="ti ti-chevron-left text-2xl text-gray-500"></i>
                </div>
                <div class="flex-1 truncate">
                    <ol class="flex items-center whitespace-nowrap primary-font text-base font-normal text-gray-700">
                        <li [ngClass]="breadcrumbData.right.secondChild ? 'max-w-1/2': 'max-w-90-percent'">
                            <div [ngClass]="breadcrumbData.right.secondChild? 'text-gray-500 font-normal hover:text-gray-600 cursor-pointer': 'text-gray-800 font-semibold pl-2'"
                                (click)="breadcrumbData.right.secondChild && changeRouteInstanceType()"
                                title="{{rrDetails?.recurring_route_name || ''}}"
                                class="truncate focus:outline-none focus:text-gray-600 dark:text-neutral-500 dark:hover:text-gray-500 dark:focus:text-gray-500">
                                {{rrDetails?.recurring_route_name || ''}}
                            </div>
                        </li>
                        <li class="max-w-1/2 w-full">
                            <div class="flex max-w-90-percent w-full items-center" *ngIf="breadcrumbData.right.secondChild">
                                <i class="ti ti-slash text-2xl"></i>
                        <li class="block items-center font-semibold text-gray-800 truncate dark:text-neutral-200"
                            aria-current="page" title="{{ breadcrumbData.right.secondChild || '' }}">
                            {{ breadcrumbData.right.secondChild || '' }}
                        </li>
                </div>
                </li>
                </ol>
            </div>
        </div>

        <!-- Route Instances list -->
        <div [hidden]="routeInstanceDetails.isOpened">
            <div class="primary-font text-base font-normal p-4 text-gray-700">
                <div class="text-gray-500 font-normal mb-4">
                    <div class="flex items-center">
                        <span>{{(routeInstanceType === 'UPCOMING' ? 'recurring_route.upcoming_instances' :
                            'recurring_route.past_instances') | translate}}</span>
                        <badge *ngIf="recurringRouteInstancePagination[routeInstanceType].firstFetchCompleted"
                            class="ml-2" [options]="updateInstanceCount()"></badge>
                    </div>
                </div>
                <div class="route-instance-list overflow-y-auto zuper-scrollbar space-y-4"
                    [ngClass]="{'past-instances': routeInstanceType=== 'PAST'}"
                    (scroll)="routeInstanceScrollHandler($event)">
                    <!-- Instance card -->
                    <div *ngFor="let routeInstance of routeInstances; trackBy:routeInstanceTrackBy"
                        class="w-full h-full min-w-72 font-normal text-base shadow text-gray-700 bg-white border border-gray-200 rounded-lg cursor-pointer"
                        (click)="openRouteInstance(true, routeInstance)">
                        <div class="w-full h-auto">
                            <!-- Content -->
                            <div class="w-full p-2 pb-0 space-y-2">
                                <div class="w-full flex items-center gap-2">
                                    <div class="min-w-fit">
                                        <div class="min-w-4 min-h-4 rounded-sm" [style.backgroundColor]="routeInstance?.color">
                                        </div>
                                    </div>
                                    <div
                                        class="primary-font text-base font-medium text-gray-700 flex space-x-1 items-center truncate">
                                        <i class="ti ti-lock text-red-600 text-2xl" *ngIf="routeInstance?.is_locked"
                                            title="{{'dispatchBoard.scheduler.route.locked' | translate}}"></i>
                                        <span class="block truncate"
                                            title="{{routeInstance?.route_name || ''}}">{{routeInstance?.route_name
                                            ||''}}</span>
                                    </div>
                                    <!-- Warnings -->
                                    <div class="flex-0 flex items-center ml-auto gap-2">
                                        <div *ngIf="recurringRouteListConflicts?.[routeInstance?.route_uid]?.count"
                                            title="{{'text.conflicts' | translate}}: {{recurringRouteListConflicts?.[routeInstance?.route_uid]?.count}}"
                                            class="flex items-center space-x-1.5 px-2 rounded-md text-orange bg-light-orange text-base font-medium cursor-pointer">
                                            <i class="ti ti-alert-triangle mt-0.5 text-2xl font-medium"></i>
                                            <span>{{recurringRouteListConflicts?.[routeInstance?.route_uid]?.count > 20?
                                                '20+': recurringRouteListConflicts?.[routeInstance?.route_uid]?.count
                                                }}</span>
                                        </div>
                                        <div (click)="$event.stopPropagation();"
                                            class="icon-button"
                                            [matMenuTriggerFor]="routeInstanceContextMenu"
                                            [matMenuTriggerData]="{routeDetails: routeInstance, source: 'instanceListing'}">
                                            <i class="ti ti-dots-vertical text-xl"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-full flex items-center mb-2 text-gray-400 font-normal text-base" *ngIf="routeInstance?.startEndTime">
                                    <span>{{routeInstance?.startEndTime || ''}}</span>
                                </div>

                            </div>
                            <!-- External Footer -->
                            <div class="px-3 py-2 bg-gray-100 mt-2 flex-0 justify-between primary-font rounded-b-lg">
                                <div class="flex justify-between items-center">
                                    <!-- Assigned to button -->
                                    <div class="flex items-center gap-1 font-medium text-base primary-font w-fit"
                                        [ngClass]="routeInstance?.is_locked ? 'cursor-default': 'cursor-pointer'"
                                        style="color: #0277BD;" *ngIf="!routeInstance?.assigned_to?.length"
                                        [matTooltip]="routeInstance?.is_locked? ('recurring_route.unlock_alert' | translate): ''"
                                        [matTooltipPosition]="'right'"
                                        (click)="$event?.stopPropagation();updateRouteInstanceAssignedTo(routeInstance, 'oneOffRoute')"
                                        [ngxTippy]="!routeInstance?.is_locked? routeInstanceAssignedToContent: null"
                                        [tippyProps]="routeInstanceUserAssignmentTippyProps">
                                        <i class="ti ti-user-plus text-2xl"></i>
                                        <span>{{'assign.employee.title' | translate}}</span>
                                    </div>
                                    <div class="flex items-center group" *ngIf="routeInstance?.assigned_to?.length">
                                        <!-- Assigned users list -->
                                        <div class="flex items-center assigned-to" #routeInstanceAssignedTo
                                            [ngClass]="routeInstance?.is_locked ? 'cursor-default': 'cursor-pointer'"
                                            (click)="$event?.stopPropagation();updateRouteInstanceAssignedTo(routeInstance, 'oneOffRoute')"
                                            [ngxTippy]="!routeInstance?.is_locked? routeInstanceAssignedToContent: null"
                                            [matTooltip]="routeInstance?.is_locked? ('recurring_route.unlock_alert' | translate): ''"
                                            [matTooltipPosition]="'right'"
                                            [tippyProps]="routeInstanceUserAssignmentTippyProps">
                                            <div *ngFor="let assignedUser of routeInstance?.assigned_to.slice(0, maxAssigedToprofile); let i=index"
                                                class="relative"
                                                [ngStyle]="{'margin-left.px': i === 0 ? 0 : -7+i, 'z-index': maxAssigedToprofile - i}">
                                                <img *ngIf="assignedUser?.hasValidProfilePicture"
                                                    class="h-6 w-6 relative rounded-full ring-2 ring-white"
                                                    loading="lazy" src="{{assignedUser?.user?.profile_picture}}" alt=""
                                                    title="{{assignedUser?.user?.first_name || ''}} {{assignedUser?.user?.last_name || ''}}">
                                                <div *ngIf="!assignedUser?.hasValidProfilePicture"
                                                    title="{{assignedUser?.user?.first_name || ''}} {{assignedUser?.user?.last_name || ''}}"
                                                    class="flex items-center justify-center h-6 w-6 ring-2 ring-white rounded-full uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200 ng-star-inserted">
                                                    {{(assignedUser?.user?.first_name || '').slice(0,1)}}
                                                </div>
                                            </div>
                                            <span *ngIf="routeInstance?.assigned_to?.length > maxAssigedToprofile"
                                                class='primary-font relative text-base text-gray-500 ml-1.5'
                                                [ngStyle]="{'margin-left.px': 6}">
                                                + {{routeInstance?.assigned_to?.length - maxAssigedToprofile}}
                                                {{'text.more' | translate}}</span>
                                        </div>
                                        <div class="bg-white ring-2 ring-gray-300 flex justify-center items-center opacity-0 shadow-lg font-medium text-center h-5 w-5 relative rounded-full group-hover:opacity-100"
                                            (click)="$event?.stopPropagation();routeInstanceAssignedTo.click()"
                                            *ngIf="!routeInstance?.is_locked"
                                            [ngClass]=" {  'ml-1': routeInstance?.assigned_to?.length > maxAssigedToprofile, 'hidden': routeInstanceUserAssignTippyData.onShow }"
                                            [ngStyle]="{'margin-left.px':4}">
                                            <i class="ti ti-user-plus text-2xl font-medium"></i>
                                        </div>
                                    </div>
                                    <span class="text-base text-gray-500 primary-font font-normal">
                                        {{routeInstance?.total_jobs || 0}} {{(routeInstance?.total_jobs > 1 ?
                                        'text.jobs': 'job') | translate}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Load More -->
                    <div class="my-2.5 flex justify-center primary-font text-base text-gray-700">
                        <span class="font-medium cursor-pointer"
                            *ngIf="recurringRouteInstancePagination[routeInstanceType].totalPages > recurringRouteInstancePagination[routeInstanceType].currentPage && !recurringRouteInstancePagination[routeInstanceType].isLoading"
                            (click)="loadMoreInstances()">{{'text.load_more' | translate }}</span>
                        <lazy-loader
                            *ngIf="recurringRouteInstancePagination[routeInstanceType].isLoading || isLoading"></lazy-loader>
                    </div>
                    <!-- No Data -->
                    <div class="flex items-center justify-center mt-3 w-full h full primary-font text-base"
                        *ngIf="!routeInstances?.length && !recurringRouteInstancePagination[routeInstanceType].isLoading && !isLoading">
                        <span class="font-semibold text-gray-700">{{'text.no_routes_found' | translate}}</span>
                    </div>
                </div>
            </div>
            <!-- Footer -->
            <div class="absolute flex justify-center w-full bottom-0 p-4 left-0 primary-font text-base border-t bg-white z-99"
                *ngIf="routeInstanceType !== 'PAST'">
                <button type="button" (click)="changeRouteInstanceType('PAST')"
                    class="px-6 text-light-blue rounded-lg font-medium py-2 border b-1 border-transparent hover:bg-gray-100">{{'recurring_route.view_past_instances'
                    | translate}}</button>
            </div>
        </div>

        <!-- Route Instances detail -->
        <div *ngIf="routeInstanceDetails.isOpened">
            <div class="flex flex-col" *ngIf="!routeInstanceDetails?.isLoading">
                <!-- Route name -->
                <div class="flex items-center justify-between border-b p-4 primary-font text-base text-gray-700">
                    <div class="flex flex-col space-y-2">
                        <div class="font-semibold flex items-center space-x-2">
                            <i class="ti ti-lock text-red-600 text-2xl mb-1"
                                *ngIf="routeInstanceDetails?.routeDetails?.is_locked"
                                title="{{'dispatchBoard.scheduler.route.locked' | translate}}"></i>
                            <div class="min-w-fit">
                                <div class="min-w-4 min-h-4 rounded-sm"
                                    [style.backgroundColor]="routeInstanceDetails?.routeDetails?.color">
                                </div>
                            </div>
                            <span class="text-break">{{routeInstanceDetails?.routeDetails?.route_name || ''}}</span>
                        </div>
                        <span class="text-gary-500 font-normal">
                            {{routeInstanceDetails?.routeDetails?.startEndTime ||''}}</span>
                        <!-- Assigned to button -->
                        <div class="flex items-center w-fit gap-1 font-medium text-base primary-font"
                            [ngClass]="routeInstanceDetails?.routeDetails?.is_locked ? 'cursor-default': 'cursor-pointer'"
                            style="color: #0277BD;" *ngIf="!routeInstanceDetails?.routeDetails?.assigned_to?.length"
                            (click)="$event?.stopPropagation();updateRouteInstanceAssignedTo(routeInstanceDetails?.routeDetails, 'oneOffRoute')"
                            [ngxTippy]="!routeInstanceDetails?.routeDetails?.is_locked? routeInstanceAssignedToContent: null"
                            [matTooltip]="routeInstanceDetails?.routeDetails?.is_locked? ('recurring_route.unlock_alert' | translate): ''"
                            [matTooltipPosition]="'right'" [tippyProps]="routeInstanceUserAssignmentTippyProps">
                            <i class="ti ti-user-plus text-2xl"></i>
                            <span>{{'assign.employee.title' | translate}}</span>
                        </div>
                        <!-- Assigned users list -->
                        <div class="group flex items-center"
                            *ngIf="routeInstanceDetails?.routeDetails?.assigned_to?.length">
                            <div class="flex items-center max-w-max assigned-to" #instanceDetailsAssignedTo
                                [ngClass]="routeInstanceDetails?.routeDetails?.is_locked ? 'cursor-default': 'cursor-pointer'"
                                (click)="$event?.stopPropagation();updateRouteInstanceAssignedTo(routeInstanceDetails?.routeDetails, 'oneOffRoute')"
                                [ngxTippy]="!routeInstanceDetails?.routeDetails?.is_locked? routeInstanceAssignedToContent: null"
                                [matTooltip]="routeInstanceDetails?.routeDetails?.is_locked? ('recurring_route.unlock_alert' | translate): ''"
                                [matTooltipPosition]="'right'" [tippyProps]="routeInstanceUserAssignmentTippyProps">
                                <div *ngFor="let assignedUser of routeInstanceDetails?.routeDetails?.assigned_to.slice(0, maxAssigedToprofile); let i=index"
                                    class="relative"
                                    [ngStyle]="{'margin-left.px': i === 0 ? 0 : -7+i, 'z-index': maxAssigedToprofile - i}">
                                    <img *ngIf="assignedUser?.hasValidProfilePicture"
                                        class="h-6 w-6 relative rounded-full ring-2 ring-white" loading="lazy"
                                        src="{{assignedUser?.user?.profile_picture}}" alt=""
                                        title="{{assignedUser?.user?.first_name || ''}} {{assignedUser?.user?.last_name || ''}}">
                                    <div *ngIf="!assignedUser?.hasValidProfilePicture"
                                        title="{{assignedUser?.user?.first_name || ''}} {{assignedUser?.user?.last_name || ''}}"
                                        class="flex items-center justify-center h-6 w-6 ring-2 ring-white rounded-full uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200 ng-star-inserted">
                                        {{(assignedUser?.user?.first_name || '').slice(0,1)}}
                                    </div>
                                </div>
                                <span *ngIf="routeInstanceDetails?.routeDetails?.assigned_to?.length > maxAssigedToprofile"
                                    class='primary-font relative text-base text-gray-500 ml-1.5'
                                    [ngStyle]="{'margin-left.px': 6}">
                                    + {{routeInstanceDetails?.routeDetails?.assigned_to?.length - maxAssigedToprofile}}
                                    {{'text.more' | translate}}</span>
                            </div>
                            <div class="bg-white ring-2 ring-gray-300 flex justify-center items-center opacity-0 shadow-lg font-medium text-center h-5 w-5 relative rounded-full group-hover:opacity-100"
                                *ngIf="!routeInstanceDetails?.routeDetails?.is_locked"
                                (click)="instanceDetailsAssignedTo.click()"
                                [ngClass]=" {  'ml-1.5': routeInstanceDetails?.routeDetails?.assigned_to?.length > maxAssigedToprofile, 'hidden': routeInstanceUserAssignTippyData.onShow }"
                                [ngStyle]="{'margin-left.px': 4 }">
                                <i class="ti ti-user-plus text-2xl font-medium"></i>
                            </div>
                        </div>
                    </div>
                    <div (click)="$event.stopPropagation();" class="icon-button min-w-fit"
                        [matMenuTriggerFor]="routeInstanceContextMenu"
                        [matMenuTriggerData]="{routeDetails: routeInstanceDetails?.routeDetails, source: 'detailsPage'}">
                        <i class="ti ti-dots-vertical text-2xl"></i>
                    </div>
                </div>
                <!-- Conflicts (if any) -->
                <div class="border-b p-4 primary-font text-base"
                    *ngIf="recurringRouteInstanceConflict?.data?.totalConflicts && !recurringRouteInstanceConflict.isLoading">
                    <div class="flex items-center route-instance-warning">
                        <div class="flex justify-between truncate w-full">
                            <div class="min-w-fit flex items-center text-orange mr-2 space-x-1.5">
                                <i class="ti ti-alert-triangle text-2xl"></i>
                                <span class="text-gary-500 font-normal flex-1 text-orange">
                                    <span
                                        class="font-medium block truncate">{{recurringRouteInstanceConflict?.data?.totalConflicts
                                        || 0}} {{'recurring_route.conflicts_in_this_instances' | translate}}</span>
                                </span>
                            </div>
                            <div (click)="openRouteInstanceWarningDialog()"
                                class="text-light-blue cursor-pointer hover:underline">
                                {{'overall_search.recently_viewed.view' | translate}}</div>
                        </div>
                    </div>
                </div>
                <div class="border-b p-4" *ngIf="recurringRouteInstanceConflict.isLoading">
                    <lazy-loader></lazy-loader>
                </div>
                <!-- Move jobs -->
                <div class="border-b p-4 primary-font text-base flex justify-between space-x-2 items-center">
                    <button type="button"
                        [ngClass]="routeInstanceDetails?.routeDetails?.is_locked ? 'bg-gray-200 cursor-not-allowed opacity-70':'hover:bg-gray-100 '"
                        [matTooltip]="routeInstanceDetails?.routeDetails?.is_locked? ('recurring_route.unlock_alert' | translate): ''"
                        (click)="!routeInstanceDetails?.routeDetails?.is_locked && editRouteInstance(routeInstanceDetails?.routeDetails)"
                        class="px-6 flex items-center justify-center w-full font-medium py-2 border b-1 border-gray-300 shadow-sm rounded-md bg-white focus:outline-none">
                        <i class="ti ti-pencil cursor-inherit text-gray-500 text-2xl mr-2"></i>
                        <span class="text-gray-500 mt-0.5">{{'route.edit' | translate}}</span>
                    </button>
                    <button type="button"
                        [ngClass]="routeInstanceDetails?.routeDetails?.is_locked ? 'bg-gray-200 cursor-not-allowed opacity-70':'hover:bg-gray-100 '"
                        [matTooltip]="routeInstanceDetails?.routeDetails?.is_locked? ('recurring_route.unlock_alert' | translate): ''"
                        (click)="!routeInstanceDetails?.routeDetails?.is_locked && emittActions({isClosed: false, isRouteInstanceSegmentOpen: true, action: 'MOVE', data: routeInstanceDetails?.routeDetails})"
                        class="px-6 flex items-center justify-center w-full font-medium py-2 border b-1 border-gray-300 shadow-sm rounded-md bg-white focus:outline-none">
                        <i class="ti ti-layout-grid cursor-inherit text-gray-500 text-2xl mr-2"></i>
                        <span class="text-gray-500 mt-0.5">{{'recurring_route.move_jobs' | translate}}</span>
                    </button>
                </div>
                <!-- Jobs list -->
                <div class="primary-font text-base font-normal p-6">
                    <span class="text-gray-700 font-medium text-base my-2">{{'text.jobs' | translate}}</span>
                    <div class="overflow-y-auto zuper-scrollbar w-full job-list my-4"
                        [ngClass]="recurringRouteInstanceConflict?.isPanelOpen? 'route-instance-warning-expanded':''">
                        <ol class=" overflow-x-hidden py-2 space-y-4">
                            <!-- Start location -->
                            <li class="relative flex-1 pb-12" *ngIf="routeInstanceDetails.routeDetails?.startLocation">
                                <div class="flex font-medium w-full">
                                    <div class="min-w-fit flex-0">
                                        <span
                                            class="w-8 h-8 border-transparent rounded-full flex justify-center items-center mr-3 z-10 text-sm"
                                            [style.background]="routeInstanceDetails.routeDetails?.primaryColor || '#0172CB'">
                                            <i class="ti ti-home text-2xl"
                                                [style.color]="routeInstanceDetails.routeDetails?.secondaryColor || '#ffffff'"></i>
                                        </span>
                                    </div>
                                    <div class="flex flex-col primary-font text-base text-gray-700 w-11/12 flex-1">
                                        <span class="font-semibold text-break">{{routeInstanceDetails.routeDetails?.startLocation ||
                                            ''}}</span>
                                    </div>
                                </div>
                            </li>
                            <!-- Job details (n) -->
                            <li class="relative flex-1 pb-12"
                                *ngFor="let routeInstnaceJob of routeInstanceDetails.routeDetails?.jobs; let i = index;">
                                <div class="flex absolute left-9 -top-11 primary-font text-base font-normal text-gray-600">
                                    <div class="flex items-center space-x-4"
                                        *ngIf="routeInstnaceJob?.travelData?.travelDistance || routeInstnaceJob?.travelData?.travelTime">
                                        <div class="flex items-center space-x-1.5" *ngIf="routeInstnaceJob?.travelData?.travelDistance" 
                                            title="{{'dispatchBoard.scheduler.route.tooltip.travel_distance' | translate}}">
                                            <i class="ti text-2xl"
                                                [ngClass]="modeOfTransportIcon[routeInstanceDetails?.transport_mode || 'CAR']"></i>
                                            <span>{{routeInstnaceJob?.travelData?.travelDistance}}</span>
                                        </div>
                                        <div class="flex items-center" *ngIf="routeInstnaceJob?.travelData?.travelTime"
                                            title="{{'dispatchBoard.scheduler.route.tooltip.travel_time' | translate}}">
                                            <i class="ti ti-clock text-2xl"></i>
                                            <span class="ml-mid">{{routeInstnaceJob?.travelData?.travelTime}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex font-medium w-full">
                                    <div class="min-w-fit flex-0">
                                        <span
                                            class="w-8 h-8 border-transparent rounded-full flex justify-center items-center mr-3 z-10 text-sm"
                                            [style.background]="routeInstanceDetails.routeDetails?.color">
                                            <span class="text-base font-normal"
                                                [style.color]="routeInstanceDetails.routeDetails?.secondaryColor || '#ffffff'">{{i
                                                + 1}}</span>
                                        </span>
                                    </div>
                                    <div
                                        class="flex flex-col primary-font text-base text-gray-700 w-11/12 flex-1">
                                        <div class="flex items-center space-x-2">
                                            <i class="ti ti-alarm text-2xl text-red-700"
                                                *ngIf="routeInstnaceJob?.isDelayedJob"></i>
                                            <i class="ti ti-repeat text-2xl text-blue-700"
                                                *ngIf="routeInstnaceJob?.isRecurrence"></i>
                                            <span class="font-semibold text-break">{{routeInstnaceJob?.job_title}}</span>
                                        </div>
                                        <span class="text-gray-600 mt-1 font-normal" *ngIf="routeInstnaceJob?.startEndTime">{{routeInstnaceJob?.startEndTime}}</span>
                                        <span class="text-gray-500 font-normal text-break">{{routeInstnaceJob?.customer_addess}}</span>
                                    </div>
                                    <div class="w-1/12 flex justify-center space-x-1">
                                        <div class="icon-button h-fit"
                                            [matMenuTriggerFor]="routeJobContextMenu"
                                            [matMenuTriggerData]="{ routeDetails: routeInstanceDetails.routeDetails, jobDetails: routeInstnaceJob, source: 'oneOffRoute' }">
                                            <i class="ti ti-dots-vertical text-2xl"></i>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <!-- End location -->
                            <li class="relative flex-1" *ngIf="routeInstanceDetails?.routeDetails?.endLocation">
                                <div class="flex absolute left-9 -top-11 primary-font text-base font-normal text-gray-600">
                                    <div class="flex items-center space-x-4"
                                        *ngIf="routeInstanceDetails?.routeDetails?.endLocationTravelData?.travelDistance || routeInstanceDetails?.routeDetails?.endLocationTravelData?.travelTime">
                                        <div class="flex items-center space-x-1.5" *ngIf="routeInstanceDetails?.routeDetails?.endLocationTravelData?.travelDistance"
                                            title="{{'dispatchBoard.scheduler.route.tooltip.travel_distance' | translate}}">
                                            <i class="ti text-2xl mb-1"
                                                [ngClass]="modeOfTransportIcon[routeInstanceDetails?.routeDetails?.transport_mode || 'CAR']"></i>
                                            <span>{{routeInstanceDetails?.routeDetails?.endLocationTravelData?.travelDistance}}</span>
                                        </div>
                                        <div class="flex items-center" *ngIf="routeInstanceDetails?.routeDetails?.endLocationTravelData?.travelTime"
                                            title="{{'dispatchBoard.scheduler.route.tooltip.travel_time' | translate}}">
                                            <i class="ti ti-clock text-2xl"></i>
                                            <span class="ml-mid">{{routeInstanceDetails?.routeDetails?.endLocationTravelData?.travelTime}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex font-medium w-full">
                                    <div class="min-w-fit flex-0">
                                        <span
                                            class="w-8 h-8  border-transparent rounded-full flex justify-center items-center mr-3 z-10 text-sm"
                                            [style.background]="routeInstanceDetails.routeDetails?.primaryColor || '#0172CB'">
                                            <div class="w-2 h-2 text-base"
                                                [style.background]="routeInstanceDetails.routeDetails?.secondaryColor || '#ffffff'">
                                            </div>
                                        </span>
                                    </div>
                                    <div class="flex flex-col primary-font text-base text-gray-700 w-11/12 flex-1">
                                        <span class="font-semibold text-break"> {{routeInstanceDetails.routeDetails?.endLocation || ''}}</span>
                                    </div>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="my-3" *ngIf="routeInstanceDetails?.isLoading">
                <lazy-loader></lazy-loader>
            </div>
        </div>
    </div>
</div>
</div>

<preview-data [drawerOpen]="previewDrawer.drawerOpen" [module]="previewDrawer.module"
    [previewDrawerName]="'rr_job_preview_drawer'" [moduleUID]="previewDrawer.moduleUID" [options]="previewDataOptions"
    (eventEmitter)="previewDrawerEventHandler($event)">
</preview-data>

<ng-template let-hide #routeInstanceAssignedToContent>
    <div class="max-h-72">
        <quick-assign-employee [prefillUsers]="routeInstanceUserAssignTippyData.prefillUsers"
            [showUserTeamAndRole]="false"
            (selectedUsers)="routeInstanceUserAssignEmitter($event)"></quick-assign-employee>
    </div>
</ng-template>

<mat-menu #routeInstanceContextMenu="matMenu" class="context-menu-wrapper">
    <ng-template matMenuContent let-routeDetails="routeDetails" let-source="source">
        <button id="unlock-route"
            class="cursor-pointer flex items-center primary-font text-base font-normal text-gray-700"
            (click)="routeInstanceContextMenuAction('ROUTE_LOCK', routeDetails, source)">
            <i class="ti text-2xl mr-1.5" [ngClass]="routeDetails?.is_locked? 'ti-lock-open': 'ti-lock'"></i>
            <span>{{(routeDetails?.is_locked? 'text.unlock_route': 'text.lock_route') | translate}}</span>
        </button>
        <button [title]="!routeDetails?.jobs?.length ? ('recurring_route.no_jobs_to_optimize' | translate) : routeDetails?.is_optimized ? ('recurring_route.already_optimzed' | translate): ''"
            *ngIf="!routeDetails?.is_locked" [disabled]="routeDetails?.is_optimized || !routeDetails?.jobs?.length" [ngClass]="routeDetails?.is_optimized || !routeDetails?.jobs?.length ? 'cursor-not-allowed' : 'cursor-pointer'">
            <div
                class="flex items-center primary-font text-base font-normal text-gray-700"
                (click)="optimizeRouteInstance(routeDetails, source)">
                <i class="ti ti-wand text-2xl mr-1.5"></i>
                <span>{{'optimise.route' | translate}}</span>
            </div>
        </button>
        <button *ngIf="!routeDetails?.is_locked"
            class="cursor-pointer flex items-center primary-font text-base font-normal text-gray-700"
            (click)="cloneRouteInstance(routeDetails)">
            <i class="ti ti-copy text-2xl mr-1.5"></i>
            <span>{{'text.clone_route' | translate}}</span>
        </button>
        <button *ngIf="!routeDetails?.is_locked"
            class="cursor-pointer text-red-600 primary-font text-base font-normal flex items-center"
            (click)="routeInstanceContextMenuAction('DELETE', routeDetails, source)">
                <i class="ti ti-trash text-2xl mr-1.5"></i>
                <span>{{'text.delete_route_instance' | translate}}</span>
        </button>
    </ng-template>
</mat-menu>

<mat-menu #routeMasterJobContextMenu="matMenu" class="context-menu-wrapper">
    <ng-template matMenuContent let-routeDetails="routeDetails" let-jobDetails="jobDetails" let-source="source">
        <button class="cursor-pointer text-red-600 primary-font text-base font-normal flex items-center"
            (click)="removeJobFromRecurringRouteMaster(routeDetails, jobDetails, source)">
            <i class="ti ti-map-off text-2xl mr-1.5"></i>
            <span>{{'alert.confirm.remove_job' | translate}}</span>
        </button>
    </ng-template>
</mat-menu>

<mat-menu #routeJobContextMenu="matMenu" class="context-menu-wrapper">
    <ng-template matMenuContent let-routeDetails="routeDetails" let-jobDetails="jobDetails" let-source="source">
        <button class="cursor-pointer text-gray-700 primary-font text-base font-normal flex items-center"
            (click)="openJobPreviewDrawer(jobDetails, routeDetails)">
            <i class="ti ti-file-description text-2xl mr-1.5"></i>
            <span>{{'view.job' | translate}}</span>
        </button>
        <button class="cursor-pointer text-red-600 primary-font text-base font-normal flex items-center"
            (click)="removeJobFromRecurringRouteMaster(routeDetails, jobDetails, source)"
            *ngIf="!routeDetails?.is_locked">
            <i class="ti ti-map-off text-2xl mr-1.5"></i>
            <span>{{'alert.confirm.remove_job' | translate}}</span>
        </button>
    </ng-template>
</mat-menu>

<mat-menu #routeMasterContextMenu="matMenu" class="context-menu-wrapper">
    <ng-template matMenuContent let-rrDetails="rrDetails">
        <button class="cursor-pointer text-gray-700 primary-font text-base font-normal flex items-center"
            (click)="routeMasterContextMenuAction('EDIT', rrDetails)">
            <i class="ti ti-pencil text-2xl mr-1.5"></i>
            <span>{{'edit' | translate}}</span>
        </button>
        <button class="cursor-pointer text-red-600 primary-font text-base font-normal flex items-center"
            (click)="routeMasterContextMenuAction('DELETE', rrDetails)">
            <i class="ti ti-trash text-2xl mr-1.5"></i>
            <span>{{'text.delete_route_master' | translate}}</span>
        </button>
    </ng-template>
</mat-menu>

<ng-template #conflictDetailsDialogContent let-hide let-data>
    <div mat-dialog-title
        class="primary-font font-semibold text-base mb-0 text-gray-700 flex justify-between border-b border-b-gray-300 zuper-dialog-header">
        <h2>{{'text.conflicts' | translate}} - {{data?.routeName}}</h2>
        <button mat-icon-button aria-label="close dialog" (click)="closeRouteInstanceWarningDialog()" tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div
        class="w-full h-full overflow-y-auto zuper-scrollbar primary-font font-normal text-base text-gray-700 conflict-content">
        <div class="relative overflow-x-auto">
            <div class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <div class="w-full">
                    <div *ngFor="let conflictType of data?.conflicts || []; let conflictTypeIndex = index;"
                        class="w-full">
                        <div class="flex w-full border-b primary-font font-normal text-base bg-white dark:bg-gray-800 dark:border-gray-700"
                            *ngIf="conflictType?.conflicts?.length">
                            <div
                                class="px-6 py-4 w-1/4 font-medium border-r text-gray-700 whitespace-nowrap dark:text-white">
                                {{conflictType?.type | titlecase}} {{'text.conflicts' | translate}}
                            </div>
                            <div class="px-6 py-4 w-full">
                                <div class="primary-font font-normal text-gray-700 text-base" *ngFor="let conflictObj of conflictType?.conflicts; let i = index;" style="white-space: pre-wrap !important;">{{i + 1}}.
                                    {{conflictObj?.message}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
        class="flex justify-end border-t border-gray-300 zuper-dialog-footer primary-font font-normal text-base text-gray-700">
        <div class="flex justify-around space-x-4">
            <button type="button" (click)="closeRouteInstanceWarningDialog()"
                class="px-6 py-2 border b-1 flex items-center border-gray-300 text-black shadow-sm text-lg font-small rounded-md  bg-white focus:outline-none btn-small">
                {{'close.text' | translate}}</button>
        </div>
    </div>
</ng-template>

<data-picker (eventEmitter)="dataPickerEventHandler($event)" [openPicker]="dataPickerDetails.openPicker"
    [pickerDrawerName]="'route_form'" [module]="dataPickerDetails.module" [options]="jobPickerOptions"
    [filter]="dataPickerDetails.filter" [timezone]="timezone"></data-picker>

<app-create-route-form [options]="editRoute.routeFormOption" [drawerName]="'rrDetailsRouteForm'" [openPicker]="editRoute.openRouteFormDrawer" [isMasterRouteEdit]="editRoute.isMasterRouteEdit"
    [data]="editRoute.data" [showRouteAlert]="true" [parentModule]="'rr_details'" [timezone]="timezone" (actionComplete)="onRouteFormDrawerClose($event)"></app-create-route-form>